import { render, staticRenderFns } from "./Sandbox_wuhan_English.vue?vue&type=template&id=563c03c7&scoped=true"
import script from "./Sandbox_wuhan_English.vue?vue&type=script&lang=js"
export * from "./Sandbox_wuhan_English.vue?vue&type=script&lang=js"
import style0 from "./Sandbox_wuhan_English.vue?vue&type=style&index=0&id=563c03c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c03c7",
  null
  
)

export default component.exports